<template>
  <div id="app">
    <!-- 头部 -->
    <Header
      :theme="meta.theme"
      :userVisible="meta.header.userVisible"
      :visible="meta.header.visible"
    />
    <!-- 全局msg提醒 exp：非营业时间 -->
    <GlobalMsgNotify
      v-if="showGlobalOpenTimeMsgMixin"
      :content="globalOpenTimeMsgContentMixin"
    />
    <!-- 视图区域 -->
    <div class="view">
      <!-- 左侧导航 -->
      <SideBar v-show="routeReady" :visible="meta.sidebar.visible" />
      <!-- 内容区域 -->
      <div class="view-container">
        <router-view></router-view>
      </div>
    </div>
    <!-- 底部 -->
    <Footer :theme="meta.theme" :visible="meta.footer.visible" />
  </div>
</template>

<script>
import Header from '@/components/Header/index.vue';
import Footer from '@/components/Footer/index.vue';
import SideBar from '@/components/SideBar/index.vue';
import GlobalMsgNotify from '@/components/GlobalMsgNotify/index.vue';
import passportMonitor from './utils/passportMonitor';
import passport from './utils/passport';
import passportH5 from './utils/passportH5';
import emitter from './utils/emitter';
import siteConfig from '@/mixins/siteConfig.js';
import checkOpenTimeObjMixin from '@/mixins/checkOpenTimeMixin';
import { delLocalStorage, setLocalStorage } from '@/utils/localStorage';
import { setSessionStorage, delSessionStorage } from '@/utils/sessionStorage';
import { mapActions } from 'vuex';
import { bill_time_tips_sw } from '@/omega/business/bill';
import stopper from '@/utils/stopper';
import { isH5 } from '@/utils/tools';
export default {
  name: 'App',
  data() {
    return {
      hasRegisterPassportH5: false,
    };
  },
  mixins: [siteConfig, checkOpenTimeObjMixin],
  components: {
    Header,
    Footer,
    SideBar,
    GlobalMsgNotify,
  },
  watch: {
    showGlobalOpenTimeMsgMixin: {
      handler(nVal) {
        if (nVal) {
          bill_time_tips_sw(); // 下单页非营业时间常驻曝光
        }
      },
    },
  },
  created() {
    this.changeDocumentTitle();
    this.getAccount();
    this.getEnums();
    this.getCheckOpenTime();
  },
  mounted() {
    this.registerPassport();
  },
  computed: {
    meta() {
      const {
        header = {},
        sidebar = {},
        footer = {},
        theme = 'light',
      } = this.$route.meta || {};
      return { header, sidebar, footer, theme };
    },
  },
  methods: {
    ...mapActions('account', ['getAccountInfo']),
    ...mapActions('common', ['getCheckOpenTime', 'getToken', 'getEnums']),
    async getAccount() {
      const data = await this.getAccountInfo();
      // 未登录，不做什么
      if (data === false) return;
      const { name } = this.$route;
      const { businessInfo } = data || {};
      // 登录状态下，没有商户信息 或者 协议需要更新 都跳转到商户信息页面
      if (!businessInfo || businessInfo?.aggrementUpdate) {
        stopper.end();
        name !== 'AddAccount' && this.$router.push({ path: '/add-account' });
        return;
      }
      // 在登录 且 有商户信息 且 协议不需要更新时，跳转到下单页
      if (name === 'home' || name === 'AddAccount') {
        this.$router.push({ path: '/bill' });
      }
    },
    registerPassport() {
      passportMonitor.registerBeforeLogin(() => {
        console.log('=========== before login ===========');
        this._clearLoginInfo();
        if (isH5) {
          /** @desc 增加1s loading **/
          let load = this.$rLoading();
          setTimeout(() => {
            load.close();
          }, 1500);
        }
      });
      passportMonitor.registerAfterLogin((res) => {
        if (isH5) {
          this._initH5LoginInfo(res);
          location.reload();
        } else {
          this._initLoginInfo();
        }
        console.log('=========== after login ===========', res);
      });
      passportMonitor.registerBeforeLogout(() => {
        console.log('=========== before logout ===========');
        this._clearLoginInfo();
      });
      passportMonitor.registerAfterLogout(() => {
        if (isH5) {
          location.reload();
        } else {
          // PC的登录方式，会自动刷新
        }
      });
      passportMonitor.registerLogin(() => {
        if (isH5) {
          if (!this.hasRegisterPassportH5) {
            this.hasRegisterPassportH5 = true;
            emitter.on('h5-login-err', (err) => {
              this.hasRegisterPassportH5 = false;
            });
            passportH5.login();
          }
        } else {
          passport.login();
        }
      });
      passportMonitor.registerLogout(() => {
        if (isH5) {
          passportH5.logout();
        } else {
          passport.logout();
        }
      });
      passportMonitor.registerLoaded(async () => {
        // console.log('registerLoaded');
      });
    },
    _initLoginInfo() {
      setLocalStorage('isLogin', true);
      setSessionStorage('afterLogin', true);
      this.getToken();
    },
    _initH5LoginInfo(res) {
      const { ticket = '', uid = '' } = res || {};
      setLocalStorage('isLogin', true);
      setLocalStorage('ticket', ticket);
      setLocalStorage('uid', uid);
      setSessionStorage('afterLogin', true);
      this.getToken();
    },
    _clearLoginInfo() {
      delLocalStorage('isLogin');
      delLocalStorage('ticket');
      delLocalStorage('uid');
      delSessionStorage('afterLogin');
    },
    changeDocumentTitle() {
      document.title = this.$t('Entrega_order__YnnH');
    },
  },
};
</script>
<style lang="scss">
// 解决IOS el-select 选项需要点击两次选中的问题
.el-scrollbar {
  .el-scrollbar__bar {
    opacity: 1 !important;
  }
}
</style>
<style lang="scss" scoped>
#app {
  max-width: 100vw;
  overflow-x: scroll;
}
.view {
  display: flex;
  min-height: calc(100vh - 60px);

  [data-site-theme='light'] & {
    background: #f5f5f5;
  }
}

.sticky-header-wrapper,
.Footer,
.view {
  min-width: 1280px;
}

.view-container {
  flex-grow: 1;
  overflow: auto;
}
//pad端
@media screen and (min-width: 768px) and (max-width: 1200px) {
  .sticky-header-wrapper,
  .Footer,
  .view {
    width: 100%;
    min-width: 100%;
  }
}

@media screen and (max-width: 1200px) {
  .sticky-header-wrapper,
  .Footer,
  .view {
    width: 100%;
    min-width: 100%;
  }
}
</style>
